import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { AddressInputFieldProps } from '../../types/addressInputFieldProps'

type AddressStreet1Props = AddressInputFieldProps

export const AddressStreet1 = ({ isDisabled = false }: AddressStreet1Props): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      label={t('customer_modal.form.address.street_address_1.label')}
      name="address.streetAddress1"
      render={({ field }) => <Input {...field} disabled={isDisabled} size="sm" />}
    />
  )
}
